import { render } from "./RequirementLab.vue?vue&type=template&id=ff9d1404&scoped=true"
import script from "./RequirementLab.vue?vue&type=script&lang=js"
export * from "./RequirementLab.vue?vue&type=script&lang=js"

import "./RequirementLab.vue?vue&type=style&index=0&id=ff9d1404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9d1404"]])

export default __exports__